module.exports = __webpack_public_path__ + "California-native-garden-new.jpg?52e7b0405f3db64ee4aee6e5ef98512f";


//////////////////
// WEBPACK FOOTER
// ./src/images/California-native-garden-new.jpg
// module id = 147
// module chunks = 0